import { ApiAccessChartWidget, Box, ApiChartConfig, Flex } from "dash-ui";
import { ApiCredentialsTypesEnum } from "dash-common";

import { totalApiUsageFetchFunction } from "../helpers/helpers";

const responsiveBoxWidth: [string, string, string, string] = [
  "100%",
  "100%",
  "100%",
  "calc(50% - 8px)",
];

const charts: ApiChartConfig[] = [
  {
    title: "Total API Access",
    fetchFunction: totalApiUsageFetchFunction({}),
  },
  {
    title: "Companies API Access",
    fetchFunction: totalApiUsageFetchFunction({
      type: ApiCredentialsTypesEnum.COMPANY,
    }),
  },
  {
    title: "Plugin Users API Access",
    fetchFunction: totalApiUsageFetchFunction({
      type: ApiCredentialsTypesEnum.PLUGIN_USER,
    }),
  },
];

const ApiMetricsPage = () => {
  return (
    <Box w="100%" p={6}>
      <Flex gap={16} flexWrap="wrap">
        {charts.map(({ title, fetchFunction }) => (
          <Box w={responsiveBoxWidth} key={title}>
            <ApiAccessChartWidget title={title} fetchFunction={fetchFunction} />
          </Box>
        ))}
      </Flex>
    </Box>
  );
};

export default ApiMetricsPage;
